// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.multi-select-container .drop-toggle {
  margin-top: 1px;
  background-color: #fff;
  border: none;
  padding: 5px 10px;
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
  border: 1px solid #707070;
  text-align: left;
}
.multi-select-container .drop-toggle span {
  opacity: 0.7;
}
.multi-select-container .drop-toggle i {
  float: right;
}
.multi-select-container .drop-show {
  padding: 4px;
  width: 222px;
  background-color: #fff;
  border: 1px solid #bababa;
  position: absolute;
  z-index: 100;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
  margin-left: 1px;
}
.multi-select-container .drop-show label {
  display: flex;
  font-size: 15px;
}
.multi-select-container .drop-show label input {
  cursor: pointer;
  margin-right: 10px;
}
.multi-select-container .drop-show label span {
  display: inline-block;
}
.multi-select-container .pill-section {
  display: block;
}
.multi-select-container .pill-section .pill {
  padding: 5px 10px;
  margin-top: 10px;
  border-radius: 30px;
  background-color: #92d46a;
  border: none;
  color: white;
  text-align: center;
  width: auto;
  font-size: 12px;
  margin-right: 10px;
}
.multi-select-container .pill-section .pill .pill-block {
  display: flex;
}
.multi-select-container .pill-section .pill .pill-block .close-button {
  margin-left: 10px;
  float: right;
  cursor: pointer;
  color: #92d46a;
  border-radius: 50%;
  background: white;
  font-size: 12px;
  font-weight: bold;
  display: inline-block;
  line-height: 0px;
  padding: 7px 4px;
  margin-top: auto;
  margin-bottom: auto;
}
.multi-select-container .pill-section .pill .pill-block .close-button:before {
  content: "×";
}`, "",{"version":3,"sources":["webpack://./apps/hybrid-app/src/app/features/shared/multi-select-dropdown/multi-select-dropdown.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAKd;EACE,eAAA;EACA,sBAPiB;EAQjB,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;EACA,gBAAA;AAHJ;AAII;EACE,YAAA;AAFN;AAII;EACE,YAAA;AAFN;AAKE;EACE,YAAA;EACA,YAAA;EACA,sBAxBiB;EAyBjB,yBAAA;EACA,kBAAA;EACA,YAAA;EAGA,0CAAA;EACA,gBAAA;AAHJ;AAII;EACE,aAAA;EACA,eAAA;AAFN;AAGM;EACE,eAAA;EACA,kBAAA;AADR;AAGM;EACE,qBAAA;AADR;AAKE;EACE,cAAA;AAHJ;AAII;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AAFN;AAGM;EACE,aAAA;AADR;AAEQ;EACE,iBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAAV;AAGQ;EACE,YAAA;AADV","sourcesContent":["$background-color_1: #fff;\n$background-color_2: #fff;\n$color_1: #bbb;\n$color_2: #fff;\n.multi-select-container {\n  .drop-toggle {\n    margin-top: 1px;\n    background-color: $background-color_1;\n    border: none;\n    padding: 5px 10px;\n    border-radius: 4px;\n    cursor: pointer;\n    width: 100%;\n    border: 1px solid #707070;\n    text-align: left;\n    span {\n      opacity: 0.7;\n    }\n    i {\n      float: right;\n    }\n  }\n  .drop-show {\n    padding: 4px;\n    width: 222px;\n    background-color: $background-color_2;\n    border: 1px solid #bababa;\n    position: absolute;\n    z-index: 100;\n    -webkit-box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);\n    -moz-box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);\n    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);\n    margin-left: 1px;\n    label {\n      display: flex;\n      font-size: 15px;\n      input {\n        cursor: pointer;\n        margin-right: 10px;\n      }\n      span {\n        display: inline-block;\n      }\n    }\n  }\n  .pill-section {\n    display: block;\n    .pill {\n      padding: 5px 10px;\n      margin-top: 10px;\n      border-radius: 30px;\n      background-color: #92d46a;\n      border: none;\n      color: white;\n      text-align: center;\n      width: auto;\n      font-size: 12px;\n      margin-right: 10px;\n      .pill-block {\n        display: flex;\n        .close-button {\n          margin-left: 10px;\n          float: right;\n          cursor: pointer;\n          color: #92d46a;\n          border-radius: 50%;\n          background: white;\n          font-size: 12px;\n          font-weight: bold;\n          display: inline-block;\n          line-height: 0px;\n          padding: 7px 4px;\n          margin-top: auto;\n          margin-bottom: auto;\n        }\n\n        .close-button:before {\n          content: '×';\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
